module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-right.81464db4.svg";